<template>
  <div class="no-dsr-admin-block">
    <h6>You have no assigned Admins for the <br>Demographic Survey Report.</h6>
    <p>
      Please reach out to your<br>
      <a target="_blank" rel="noopener noreferrer" :href="`mailto:support@datapeople.io?subject=Demographic%20Survey%20Report%20Administrator%20Inquiry`">Customer Success Manager</a>
      to select one.
    </p>
  </div>
</template>

<style scoped lang="less">
.no-dsr-admin-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 213px;
  width: 100%;
  background: @bg-canvas;
  border-radius: 8px;
  text-align: center;
}

h6 {
  font-size: 13px;
  font-weight: 500;
  line-height: 150%;
  color: @text-darkest;
}

p {
  font-size: 12px;
  font-weight: 500;
  line-height: 150%;
  color: @text-light;
}

a {
  color: @text-brand;
  cursor: pointer;
}
</style>
